// Configurator options, constrained to what the supplier can produce
// (ops/supplier-spec.md, ops/order-automation.md). Update here only; the UI,
// validation and the server all read from this module.
export const BRAND = 'Pendspin'

// Fonts = the supplier dropdown on GoldHillJewelry "name_cheap". `supplier` is the exact value sent
// to the supplier. `file` is only a PREVIEW approximation: the supplier's font chart images are not
// extracted yet, so each supplier font is paired with a similar bundled web font.
// TODO(follow-up): trace the real 6 fonts from the supplier's chart.
/** @type {import('../types/pendant.js').FontOption[]} */
export const FONTS = [
  {
    id: 'font-1',
    supplier: 'Font:1',
    label: 'Font 1',
    file: '/fonts/great-vibes-latin-400-normal.woff',
    style: 'script',
  },
  {id: 'font-6', supplier: 'Font:6', label: 'Font 6', file: '/fonts/pacifico-latin-400-normal.woff', style: 'script'},
  {
    id: 'font-35',
    supplier: 'Font:35',
    label: 'Font 35',
    file: '/fonts/playfair-display-latin-700-normal.woff',
    style: 'serif',
  },
  {
    id: 'font-40',
    supplier: 'Font:40',
    label: 'Font 40',
    file: '/fonts/montserrat-latin-600-normal.woff',
    style: 'sans',
  },
  {
    id: 'font-41',
    supplier: 'Font:41',
    label: 'Font 41',
    file: '/fonts/playfair-display-latin-700-normal.woff',
    style: 'serif',
  },
  {
    id: 'font-42',
    supplier: 'Font:42',
    label: 'Font 42',
    file: '/fonts/pacifico-latin-400-normal.woff',
    style: 'script',
  },
]

/** @type {import('../types/pendant.js').MetalOption[]} */
export const METALS = [
  // color = base reflectance (F0) of the real metal, used with metalness 1. `supplier` = supplier option name.
  {
    id: 'silver',
    supplier: 'silver',
    label: 'Silver',
    color: '#f4f1e8',
    swatch: 'linear-gradient(135deg,#fdfdfd,#b9bcc4)',
    roughness: 0.14,
  },
  {
    id: 'gold',
    supplier: 'gold plated',
    label: 'Gold',
    color: '#ffc258',
    swatch: 'linear-gradient(135deg,#ffe9a8,#c98a1b)',
    roughness: 0.12,
  },
  {
    id: 'rose-gold',
    supplier: 'rose plated',
    label: 'Rose gold',
    color: '#f0a08a',
    swatch: 'linear-gradient(135deg,#ffd4c4,#b9654f)',
    roughness: 0.13,
  },
]

/** @type {number[]} */
export const CHAIN_LENGTHS = [12, 14, 16, 18, 20, 22] // inches; supplier name_cheap list
/** @type {{text: string, font: string, metal: import('../types/pendant.js').MetalId, chain: number}} */
export const DEFAULTS = {text: 'Luna', font: 'font-1', metal: 'gold', chain: 18}

/** @type {import('../types/pendant.js').Limits} */
export const LIMITS = {
  maxChars: 256, // supplier hard limit
  recommendedChars: 12, // pendant is only ~4x6 mm
  allowedChars: /^[A-Za-z0-9 '&.-]+$/,
  pendantMaxSize: 150, // scene units (longest side of the pendant)
  svgMaxBytes: 256 * 1024,
  svgMaxElements: 2000,
  svgMaxShapes: 150,
}

// v1: custom SVG shapes are NOT allowed (they need supplier messaging). Code path kept behind this flag.
export const SVG_ENABLED = false

// Retail prices in USD cents (plan: word $49, custom shape $79). Free US shipping.
/** @type {Record<import('../types/pendant.js').Mode, number>} */
export const PRICES = {word: 4900, svg: 7900}
export const SHIPPING_COUNTRIES = ['US']
/** @type {import('../types/pendant.js').OrderStatus[]} */
export const ORDER_STATUSES = ['pending_payment', 'paid', 'fulfilling', 'shipped', 'cancelled', 'payment_failed']
export const PREVIEW_MAX_BYTES = 1_500_000

// Supplier cost (name_cheap, USD by chain length): max_cogs_usd = (item + shipping) * 1.2
export const SUPPLIER_SHIPPING_USD = 4.5
/** @type {import('../types/pendant.js').SupplierItemPrices} */
export const SUPPLIER_ITEM_USD = {
  'gold plated': {12: 18, 14: 22.8, 16: 24, 18: 25.2, 20: 26.4, 22: 27.6},
  silver: {12: 18, 14: 21, 16: 24, 18: 25.2, 20: 26.4, 22: 27.6},
  'rose plated': {12: 18, 14: 22.8, 16: 24, 18: 25.2, 20: 26.4, 22: 27.6},
}
